<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div class="content_head">
          <div class="content_head_ico">
            <img src="@/assets/images/worktable/titleguoducolor.png" alt=""/>
          </div>
          <div class="content_head_title">质量台账</div>
          <div class="content_head_button">
            <div class="content_head_seek content_searchlistbox">
              <lk-button img="searchlist.png" @click="searchlistshow=!searchlistshow"></lk-button>
              <img v-show="searchlistshow" class="content_searchlist" src="@/assets/images/xiala.png" alt="">
            </div>
            <div class="content_head_seek">
              <lk-button img="export.png" type="lk_button_blue" @click="exportExcel">导出</lk-button>
            </div>
          </div>
        </div>
        <div class="searchlistbox" v-show="searchlistshow">
          <div class="content_head_seek">
            <el-input placeholder="请输入编号" v-model="number" class="input-with-select">
            </el-input>
          </div>
          <div class="content_head_seek">
            <el-select v-model="grainBelong" filterable placeholder="粮权所属">
              <el-option
                  v-for="item in grainBelongList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="content_head_seek">
            <el-cascader
                v-model="grainKind"
                :options="grainKindList"
                placeholder="粮食品种"
                clearable
                filterable
            ></el-cascader>
          </div>
          <div class="content_head_seek">
            <el-select v-model="checkResult" filterable placeholder="质检结果">
              <el-option
                  v-for="item in checkResultList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="content_head_seek">
            <div class="block">
              <el-date-picker
                  v-model="timepicker"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="content_head_seek">
            <lk-button @click="getDataList(1)">查询</lk-button>
          </div>
          <div class="content_head_seek">
            <lk-button type="lk_button_blue" @click="searchReset">重置</lk-button>
          </div>
        </div>
        <div class="Notice_list">
          <el-table :data="Notice" style="width: 100%">
            <el-table-column prop="number" label="编号" width="160" align="center"></el-table-column>
            <el-table-column prop="barnNameFi" label="仓房" align="center"></el-table-column>
            <el-table-column prop="foodNature" label="粮食性质" align="center"></el-table-column>
            <el-table-column prop="grainBelong" label="粮权所属" align="center"></el-table-column>
            <el-table-column prop="grainKind" label="粮食品种" align="center"></el-table-column>
            <el-table-column prop="grainLevel" label="粮食等级" align="center"></el-table-column>
            <el-table-column prop="checkType" label="质检类型" align="center"></el-table-column>
            <el-table-column prop="checkTime" label="质检时间" align="center"></el-table-column>
            <el-table-column prop="checkStatusFi" label="质检结果" align="center"></el-table-column>
            <el-table-column prop="checkPerson" label="检验人" align="center"></el-table-column>
            <!--            <el-table-column label="粮情明细" align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-button type="text" size="small" @click="alertShow('粮情明细',scope.row,'1573px')">查看</el-button>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button v-if="permissionFindIs" type="text" size="small" @click="buttonSwitch(scope.row.id)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging">
          <div class="block">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page="currentPage"
                :page-size="pageSize"
                :page-sizes="config.pagesizes"
                layout="total, prev, pager, next, jumper,sizes"
                :total="totalPage"
            >
            </el-pagination>
          </div>
        </div>
        <!--        保存提示-->
        <el-dialog
            :title="showid"
            :visible.sync="showalert"
            :width="showwidth"
        >
          <div class="showbodymax" v-if="showid === '详情'">
            <div class="showbody showbody_padding showbody_bor">
              <div class="inputbox inputbox_marginr">
                <div class="title">编号</div>
                <div class="input">10210</div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">质检单号</div>
                <div class="input">102100000000</div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">库点</div>
                <div class="input">镇海库</div>
              </div>
              <div class="inputbox">
                <div class="title">库房编号</div>
                <div class="input">OP1</div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">仓房类型</div>
                <div class="input">商品粮</div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">粮权所属</div>
                <div class="input">浙粮集团</div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">仓管员</div>
                <div class="input">张三</div>
              </div>
              <div class="inputbox">
                <div class="title">联系电话</div>
                <div class="input">18000000000</div>
              </div>
            </div>
            <div class="showbody showbody_padding showbody_bor">
              <div class="inputbox inputbox_marginr">
                <div class="title">编号</div>
                <div class="input">10210</div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">质检类型</div>
                <div class="input">入库质检</div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">粮食品种</div>
                <div class="input">小麦</div>
              </div>
              <div class="inputbox">
                <div class="title">粮食等级</div>
                <div class="input">国际三等</div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">总数量(kg)</div>
                <div class="input">500</div>
              </div>
              <div class="inputbox">
                <div class="title">入库时间</div>
                <div class="input">2020-10-10</div>
              </div>
              <div class="inputbox_w100">
                <div class="title">备注</div>
                <div class="input">无</div>
              </div>
            </div>
            <div class="Notice_alert showbody_padding showbody_bor">
              <div class="showbody">
                <div class="inputbox inputbox_marginr">
                  <div class="title">质检名称</div>
                  <div class="input"></div>
                </div>
                <div class="inputbox inputbox_marginr">
                  <div class="title">质检模板</div>
                  <div class="input"></div>
                </div>
                <div class="inputbox inputbox_marginr">
                  <div class="title">质检标准</div>
                  <div class="input"></div>
                </div>
              </div>
              <el-table border :data="alertNotice" style="width: 100%">
                <el-table-column prop="str1" label="质检项" align="center"></el-table-column>
                <el-table-column prop="str2" label="检测值" align="center"></el-table-column>
                <el-table-column prop="str3" label="判断标准" align="center"></el-table-column>
                <el-table-column prop="str4" label="结果" align="center"></el-table-column>
              </el-table>
            </div>
            <div class="showbody showbody_padding showbody_bor">
              <div class="inputbox inputbox_marginr">
                <div class="title">质检结果</div>
                <div class="input"></div>
              </div>
              <div class="inputbox inputbox_marginr">
                <div class="title">质检时间</div>
                <div class="input"></div>
              </div>
              <div class="inputbox inputbox_marginr ">
                <div class="title">质检人</div>
                <div class="input"></div>
              </div>
              <div class="inputbox">
                <div class="title">审核人</div>
                <div class="input"></div>
              </div>
              <div class="inputbox">
                <div class="title">审核时间</div>
                <div class="input"></div>
              </div>
            </div>
          </div>
          <div v-show="showid === '粮情明细'">
            <div class="showbody showbody_padding showbody_bor">
              <div class="alert_inputbox alert_inputboxmax inputbox_marginr" style="width: 15%">
                <div class="title">库点</div>
                <div class="input">
                  <el-input placeholder="" v-model="alert_json.val1" class="input-with-select" disabled></el-input>
                </div>
              </div>
              <div class="alert_inputbox alert_inputboxmax inputbox_marginr" style="width: 15%">
                <div class="title">仓房</div>
                <div class="input">
                  <el-input placeholder="" v-model="alert_json.val1" class="input-with-select" disabled></el-input>
                </div>
              </div>
              <div class="alert_inputbox alert_inputboxmax inputbox_marginr" style="width: 15%">
                <div class="title">粮食种类</div>
                <div class="input">
                  <el-input placeholder="" v-model="alert_json.val1" class="input-with-select" disabled></el-input>
                </div>
              </div>
              <div class="alert_inputbox alert_inputboxmax inputbox_marginr" style="width: 15%">
                <div class="title">粮食等级</div>
                <div class="input">
                  <el-input placeholder="" v-model="alert_json.val1" class="input-with-select" disabled></el-input>
                </div>
              </div>
              <div class="alert_inputbox alert_inputboxmax" style="width: 15%">
                <div class="title">产地</div>
                <div class="input">
                  <el-input placeholder="" v-model="alert_json.val1" class="input-with-select" disabled></el-input>
                </div>
              </div>
              <div class="alert_inputbox alert_inputboxmax" style="width: 15%">
                <div class="title">入库时间</div>
                <div class="input">
                  <el-input placeholder="" v-model="alert_json.val1" class="input-with-select" disabled></el-input>
                </div>
              </div>
            </div>
            <div class="showbody showbody_padding showbody_bor">
              监测时间:2020/12/19 10:30:00
            </div>
            <div class="showbody">
              <div class="inputbox_color alert_inputboxmax inputbox_marginr">
                <div class="input1">
                  粮食温度：10.3℃
                </div>
              </div>
              <div class="inputbox_color alert_inputboxmax inputbox_marginr">
                <div class="input2">
                  仓内温度：10.3℃
                </div>
              </div>
              <div class="inputbox_color alert_inputboxmax inputbox_marginr">
                <div class="input3">
                  仓内湿度：10%
                </div>
              </div>
              <div class="inputbox_color alert_inputboxmax inputbox_marginr">
                <div class="input4">
                  仓外温度：13.2℃
                </div>
              </div>
              <div class="inputbox_color alert_inputboxmax inputbox_marginr">
                <div class="input5">
                  仓外湿度：20%
                </div>
              </div>
            </div>
            <div class="showbody showbody_padding">
              <el-date-picker
                  v-model="month"
                  type="month"
                  placeholder="选择月">
              </el-date-picker>
              <lk-button img="search.png"></lk-button>
            </div>
            <div class="showbody">
              <div class="echartsbox" ref="mbleacharts"></div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import {httpToken} from "@/utils/http";
import qs from "qs";
import {export2Excel} from "@/utils/util";
import {mapMutations} from "vuex";
import {getGrainKindDictionary} from "@/utils/warehouseInOut";
import {getjudgePermission} from '@/utils/server/permission'
const echarts = require("echarts");
export default {
  name: "Standbook",
  data() {
    return {
      permissionFindIs:false,//详情权限
      // 弹框展示相关 标题  显示的开关  弹框宽度  弹框数据
      showid: 0,
      showalert: false,
      showwidth: "676px",
      showdata: {},
      alertNotice: [],
      Notice: [],
      alert_json: {},
      currentPage: 1,
      pageSize:10,
      totalPage: 10,
      number: "",
      grainNature: "",
      grainBelong: "",
      grainKind: "",
      checkResult: "",
      timepicker: "",
      warehouseNumberList: [],
      grainNatureList: [],
      grainBelongList: [],
      grainKindList: getGrainKindDictionary(),
      checkResultList: [
        {value: null, label: '全部'},
        {value: '合格', label: '合格'},
        {value: '不合格', label: '不合格'}],
      searchlistshow: false,
      columns: [
        {title: "编号", key: "number"},
        {title: "仓房", key: "barnNameFi"},
        {title: "粮食性质", key: "foodNature"},
        {title: "粮权所属", key: "grainBelong"},
        {title: "粮食品种", key: "grainKind"},
        {title: "粮食等级", key: "grainLevel"},
        {title: "质检类型", key: "checkType"},
        {title: "质检时间", key: "checkTime"},
        {title: "质检结果", key: "checkStatusFi"},
        {title: "检验人", key: "checkPerson"},
      ],
      month: ''
    };
  },
  methods: {
    ...mapMutations('Quality', ['setQualityId', 'setQualityBack']),
    // 获取数据列表
    getDataList(page) {
      this.currentPage = page
      let paramData = [{column: 'unit', type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId}]
      if (this.number) {
        paramData.push({column: 'number', type: 'eq', value: this.number})
      }
      if (this.grainNature) {
        paramData.push({column: 'grain_nature', type: 'eq', value: this.grainNature})
      }
      if (this.grainBelong) {
        paramData.push({column: 'grain_belong', type: 'eq', value: this.grainBelong})
      }
      if (this.grainKind.length!==0) {
        paramData.push({column: 'grain_kind', type: 'eq', value: this.grainKind[1]})
      }
      if (this.timepicker) {
        paramData.push({column: "create_date", type: "ge", value: this.timepicker[0]});
        paramData.push({column: "create_date", type: "le", value: this.timepicker[1] + " 23:59:59"});
      }
      httpToken({
        method: 'post',
        url: '/granary-quality-ledger/show',
        data: qs.stringify({
          page: page,
          paramData: JSON.stringify(paramData),
          rows: this.pageSize,
        })
      }).then(res => {
        // console.log(res)
        this.Notice = []
        let Data = res.data.data
        if (status === 'delete' && Data.pages < this.currentPage && Data.pages !== 0) {
          this.currentPage = Data.pages
          this.getDataList(this.currentPage)
          return
        }
        let DataList = Data.records
        DataList.forEach((item) => {
          item['checkType'] = '入库检测'
          // item.checkTime = item.checkTime.replace('T', ' ')
        })
        this.Notice = Data.records
        this.totalPage = Data.total
      })
    },
    // 搜索重置
    searchReset() {
      this.number = ''
      this.grainNature = ''
      this.grainBelong = ''
      this.grainKind = []
      this.checkResult = ''
      this.timepicker = ''
    },
    // 导出
    exportExcel() {
      export2Excel(this.columns, this.Notice, "质量台账");
    },
    // 详情按键
    buttonSwitch(id) {
      this.setQualityId(id);
      this.setQualityBack(this.$store.state.leftNav)
      this.$emit('update:comName', 'StandbookDetail')
    },
    // 获取粮权所属的下拉选项
    getGrainBelongOptions() {
      httpToken({
        url: '/grain-owned/all',
        method: 'post'
      }).then(res => {
        // console.log(res.data.data)
        const belongList = res.data.data
        this.grainBelongList = []
        for (let j = 0; j < belongList.length; j++) {
          this.grainBelongList.push(
              {
                value: belongList[j].companyName,
                label: belongList[j].companyName
              })
        }
      })
    },
    alertShow(str, val, width) {
      console.log(str, val);
      this.showid = str;
      this.showwidth = width;
      this.showdata = val;
      this.showalert = true;
      if (str === "粮情明细") {
        let data = [
          {
            count: 79,
            time: "2012",
          },
          {
            count: 127,
            time: "2013",
          },
          {
            count: 147,
            time: "2014",
          },
          {
            count: 120,
            time: "2015",
          },
          {
            count: 220,
            time: "2016",
          },
          {
            count: 230,
            time: "2017",
          },
          {
            count: 174,
            time: "2018",
          },
          {
            count: 157,
            time: "2019",
          },
          {
            count: 137,
            time: "2020",
          },
        ];
        let data2 = [
          {count: 31},
          {count: 131},
          {count: 231},
          {count: 131},
          {count: 221},
          {count: 131},
          {count: 311},
          {count: 211},
          {count: 171},
        ];
        let data3 = [
          {count: 331},
          {count: 231},
          {count: 65},
          {count: 53},
          {count: 123},
          {count: 321},
          {count: 222},
          {count: 86},
          {count: 150},
        ];
        this.$nextTick(() => {
          this.ckqkecharts(
              echarts.init(this.$refs.mbleacharts),
              data,
              data2,
              data3
          );
        });
      }
    },
    handleCurrentChange(val) {
      this.getDataList(val)
    },
    handleSizeChange(val){
      this.pageSize=val
      this.getDataList(this.currentPage);
    },
    ckqkecharts(echart, json, json1, json2) {
      let time = [];
      let value = [];
      let value1 = [];
      let value2 = [];
      for (let i = 0; i < json.length; i++) {
        time.push(json[i].time);
        value.push(this.goulufun(json[i].count));
        value1.push(this.goulufun(json1[i].count));
        value2.push(this.goulufun(json2[i].count));
      }
      let datas = [
        {
          name: "标准粮温",
          data: value,
          type: "line",
          smooth: true,
          symbol: "none", // 取消折点圆圈
          connectNulls: true,
          itemStyle: {
            normal: {
              color: "#376BF4",
            },
          },
          lineStyle: {
            color: "#376BF4",
          },
        },
        {
          name: "最高粮温",
          data: value1,
          type: "line",
          smooth: true,
          symbol: "none", // 取消折点圆圈
          connectNulls: true,
          itemStyle: {
            normal: {
              color: "#F29B76",
            },
          },
          lineStyle: {
            color: "#F29B76",
          },
        },
        {
          name: "全仓平均粮温",
          data: value2,
          type: "line",
          smooth: true,
          symbol: "none", // 取消折点圆圈
          connectNulls: true,
          itemStyle: {
            normal: {
              color: "#7ECEF4",
            },
          },
          lineStyle: {
            color: "#7ECEF4",
          },
        },
      ];
      let option = {
        backgroundColor: "rgba(255,255,255,0)",
        legend: {
          orient: "vertical",
          itemWidth: 28,
          itemHeight: 10,
          top: 16,
          right: 20,
          data: [
            {
              name: "标准粮温",
              icon: "roundRect",
              textStyle: {
                color: "#376BF4",
              },
            },
            {
              name: "最高粮温",
              icon: "roundRect",
              textStyle: {
                color: "#F29B76",
              },
            },
            {
              name: "全仓平均粮温",
              icon: "roundRect",
              textStyle: {
                color: "#7ECEF4",
              },
            },
          ],
        },
        title: {},
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let str = params[0].axisValue + "年" + "<br>";
            let unti = "℃";
            for (let i = 0; i < params.length; i++) {
              str +=
                  params[i].seriesName + ":" + params[i].value + unti + "<br>";
            }
            return str;
          },
        },
        grid: {
          left: "0%",
          right: "2%",
          bottom: "5%",
          top: "12%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: time,
          axisLabel: {
            show: true,
            textStyle: {
              color: "rgba(124, 122, 122, 1)",
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(238, 238, 238, 1)",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                // color: 'rgba(255, 255, 255, 0.54)'
                color: "rgba(124, 122, 122, 1)",
              },
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(238, 238, 238, 1)",
                type: "dashed",
              },
            },
          },
        ],
        series: datas,
      };
      echart.setOption(option, true);
      window.addEventListener("resize", function () {
        echart.resize();
      });
    }
  },
  mounted() {
    getjudgePermission('1124').then(res=>{
      this.permissionFindIs=res
    })
    this.getGrainBelongOptions()
    this.getDataList(1)
  }
};
</script>
<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 0 20px;
}

.showbodymax {
  width: 100%;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #969696;

  .title {
    margin-bottom: 24px;
  }

  .Notice_alert {
    ::v-deep .el-table th {
      background-color: #f4f7fd;
    }

    ::v-deep .el-table thead {
      color: #969696;
    }
  }
}

.noticebox {
  width: 622px;
  margin: 32px auto;
  padding: 30px 40px;
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 0 3px 7px 0 rgba(91, 117, 148, 0.26);

  .noticebox_fotbox {
    width: 100%;
    margin-top: 30px;
    display: flex;
    font-size: 14px;
    font-family: PingFang SC, serif;
    font-weight: 500;
    color: #383838;

    .fottitle_left {
    }

    .fottitle_right {
      margin-left: auto;
    }
  }

  .noticebox_table {
    width: 100%;
    min-height: 25px;
    text-align: left;
    border-color: #DCDCDC;
    border-collapse: collapse;
    font-size: 14px;

    tr {
      td {
        padding: 15px;
        box-sizing: border-box;
        vertical-align: top;
      }

      td:nth-child(odd) {
        width: 90px;
        height: 40px;
      }

      td:nth-child(even) {
        width: 180px;
        height: 40px;
      }
    }

    .bigtr {
      .bigtd {
        width: 100%;
        height: 200px;

        .Notice_alert {
          -webkit-text-size-adjust: none;
          font-size: 9px;
          color: #969696;

          ::v-deep .el-table {
            -webkit-text-size-adjust: none;
            font-size: 9px;
          }

          ::v-deep .el-table th {
            background-color: #f4f7fd;
            color: #969696;
          }

          ::v-deep .el-table .el-table__cell {
            padding: 6px 0;
          }

          ::v-deep .el-table thead {
            color: #969696;
            -webkit-text-size-adjust: none;
            font-size: 9px;
          }
        }
      }
    }
  }

  .noticebox_title {
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #383838;
    margin-bottom: 30px;
  }

  .showbut {
    position: absolute;
    right: 36px;

    .el-button {
      padding: 10px 42px;
      font-size: 16px;
    }
  }
}

.table_title {
  display: flex;
  margin-bottom: 20px;

  .table_title_left {

  }

  .table_title_right {
    margin-left: auto;
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #f5f8ff;
  }

  ::v-deep .el-table thead {
    color: #000000;
  }
}

.showbody_padding {
  padding: 30px 0;
}

.showbody_bor {
  border-top: 1px solid #eeeeee;
}

.showbody {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  font-family: Source Han Sans CN, serif;
  font-weight: 400;
  color: #969696;

  .echartsbox {
    width: 100%;
    height: 500px;
  }

  .inputbox_color {
    width: 15%;
    align-items: center;

    div {
      width: 100%;
      height: 38px;
      font-size: 18px;
      font-family: Source Han Sans CN, serif;
      font-weight: 400;
      text-align: center;
      line-height: 38px;
    }

    .input1 {
      background: #FCD4D5;
      border: 1px solid #F43749;
      color: #EF3340;
    }

    .input2 {
      color: #376BF4;
      background: #D8E1FC;
      border: 1px solid #376BF4;
    }

    .input3 {
      background: #D4F3FB;
      border: 1px solid #2DB7DA;
      color: #26AED1;
    }

    .input4 {
      background: #F4D4FB;
      border: 1px solid #A632E9;
      color: #A632E9;
    }

    .input5 {
      background: #D4FBD7;
      border: 1px solid #2CB311;
      color: #2CB311;
    }
  }

  .alert_inputbox {
    width: 20%;
    align-items: center;

    ::v-deep .el-input {
      width: 100%;
      max-width: 217px;
    }

    .title {
      margin-bottom: 8px;
      width: 100%;
      box-sizing: border-box;
      padding-right: 20px;
    }

    .input {
      width: 100%;
    }
  }

  .alert_inputboxmax {
    ::v-deep .el-input {
      width: 100%;
      max-width: 100%;
    }
  }

  .inputbox_marginr {
    margin-right: 5%;
  }

  .inputbox {
    width: 20%;
    margin-bottom: 14px;

    .title {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #969696;
      margin-bottom: 14px;
    }

    .input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      overflow: auto;
      white-space: nowrap;
      box-sizing: border-box;
      padding-left: 10px;
      background: #f4f7fd;
      border: 1px solid #dcdcdc;
    }

    .input::-webkit-scrollbar {
      display: none;
    }
  }

  .inputbox_w100 {
    width: 95%;
    margin-bottom: 14px;

    .title {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #969696;
      margin-bottom: 14px;
    }

    .input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      overflow: auto;
      white-space: nowrap;
      box-sizing: border-box;
      padding-left: 10px;
      background: #f4f7fd;
      border: 1px solid #dcdcdc;
    }

    .input::-webkit-scrollbar {
      display: none;
    }
  }
}

.searchlistbox {
  width: 100% !important;
  padding-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #376bf4;
  display: flex;
  flex-wrap: wrap;

  .content_head_seek {
    margin-left: 20px;
    margin-bottom: 20px;
    // width: 25%;
  }
}

.content_head {
  width: 100%;
  display: flex;
  font-size: 18px;
  margin-bottom: 10px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    padding-top: 4px;
    margin-right: 10px;
    // margin: auto 10px auto 0;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    white-space: nowrap;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1b1b1b;
  }

  .content_head_button {
    flex: auto;
    max-width: 1050px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    .content_searchlistbox {
      position: relative;

      .content_searchlist {
        position: absolute;
        top: 40px;
        left: calc(50% - 9px);
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      margin-bottom: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }
    }
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
